<template>
  <a-table
    :columns="columns"
    :data-source="tableList"
    @change="onChange"
    :pagination="{ defaultPageSize: 5, total: total }"
  >
    <div
      slot="filterDropdown"
      slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
      class='custom-filter-dropdown'
    >
      <a-input
        v-ant-ref="c => (searchInput = c)"
        :placeholder="`搜索${column.title}`"
        :value="selectedKeys[0]"
        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [''])"
        @pressEnter="() => handleSearch(selectedKeys, confirm)"
        style="width: 188px; margin-bottom: 8px; display: block;"
      />
      <a-button
        type='primary'
        @click="() => handleSearch(selectedKeys, confirm)"
        icon="search"
        size="small"
        style="width: 90px; margin-right: 8px"
      >搜索
      </a-button>
      <a-button
        @click="() => handleReset(clearFilters)"
        size="small"
        style="width: 90px"
      >重置
      </a-button>
    </div>
    <a-icon
      slot="filterIcon"
      slot-scope="filtered"
      type="search"
      :style="{ color: filtered ? '#108ee9' : undefined }"
    />
  </a-table>
</template>
<script>
export default {
  props: {
    tableList: Array,
    total: Number,
    setPageNum: Function
  },
  data () {
    return {
      searchText: '',
      columns: [
        {
          title: '城市',
          dataIndex: 'cityName',
          ellipsis: true,
          width: 117,
          align: 'left',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) => {
           return record.cityName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: '小区名称',
          dataIndex: 'communityName',
          ellipsis: true,
          width: 211,
          align: 'left',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) => {
           return record.communityName
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: '点位名称',
          dataIndex: 'deviceName',
          ellipsis: true,
          width: 188,
          align: 'left'

        },
        {
          title: '设备型号',
          ellipsis: true,
          dataIndex: 'version',
          width: 164,
          align: 'left',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) => {
            return record.version
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: 'MAC',
          dataIndex: 'mac',
          ellipsis: true,
          width: 252,
          align: 'left',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) => {
           return record.mac
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },

        },
        {
          title: '下发时间',
          ellipsis: true,
          dataIndex: 'sendTime',
          width: 200,
          align: 'left'

        }
      ],
      pageNum: 1,
    };
  },

  methods: {
    onChange (val) {
      this.setPageNum(val.current)
      // this.pageNum = val.current
    },
    //表格内搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
  },
};
</script>
<style lange="less" scoped>
/deep/ .ant-table-thead > tr > th,
/deep/ .ant-table-tbody > tr > td {
  padding-left: 16px;
}
.custom-filter-dropdown {
  padding: 10px;
}
</style>
